import { METHOD_GET } from 'api/constants/methods'
import { namespaceFetchWrapper as nsfw } from '.'

const suffix = 'good_practices'

export const getGoodPractices = () => nsfw(METHOD_GET, `${suffix}`)
